import styles from '../../styles/Tokens.module.scss';

function Product({ _id, credits, price, description }) {
    const label = description?.trim()
        ? description
        : `${credits} ${credits > 1 ? "Tokens" : "Token"}`;

    return (
        <div key={_id} className={styles.product}>
            <p><strong>{label}</strong></p>
            <a href={`/gift-vouchers/checkout/${_id}`} className="btn btnPrimary">£{(price / 100).toFixed(2)}</a>
        </div>
    )
}

export default Product;
